import { render, staticRenderFns } from "./EmailListComponent.vue?vue&type=template&id=3c22c6f4"
import script from "./EmailListComponent.vue?vue&type=script&lang=js"
export * from "./EmailListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports